<template>
  <div
    class="jRules jFlow">
    <div class="selected-bottom-rules show-floating">
      <b-row>
        <b-col>
          <slot/>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  methods: {
    hide(route) {
      const elem = document.getElementsByClassName('selected-bottom-rules');
      elem[0].classList.remove('show-floating');
      elem[0].classList.add('hide-floating');
      setTimeout(() => {
        // elem[0].classList.remove('selected-bottom-rules');
        if (route) {
          this.$router.replace(route);
        }
      }, 200);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/new-floating-templete/jFloatingPrompt.vue